export type Case = {
  id: number
  name: string
  description: string
  kind: number
  active: boolean
  source: string
  supports_free_keys: boolean
  price_keys: number
  expired_at: string
}

export enum LootBoxOrder {
  'GAMED Case' = 1,
  'Apps Center Case' = 2,
  'Telegram Gift Case' = 3,
  'CARGO Case' = 6,
  'Ambassador Case' = 7,
  'Trending Box' = 8,
  'PS 5 Limited Case' = 4,
  'Steam On! Case' = 5,
}

export enum CaseKind {
  UNIQUE = 5,
  GAMED = 1,
  DOTA = 2,
  CS = 3,
}

export enum GameIdEnum {
  'DOTA 2' = 570,
  'CS2' = 730,
}

export const BoxToSortingTab = {
  'GAMED Case': 'MiniApps',
  'Telegram Gift Case': 'MiniApps',
  'Ambassador Case': 'MiniApps',
  'CARGO Case': 'MiniApps',
  'Trending Box': 'MiniApps',
}

export enum RewardRarity {
  'Legendary' = 5,
  'Epic' = 4,
  'Rare' = 3,
  'Uncommon' = 2,
  'Common' = 1,
}

export const CaseSubnameEnRu = {
  'GAMED Case': ['Standard Case', 'Обычный'],
  'Telegram Gift Case': ['Standard Case', 'Обычный'],
  'Trending Box': ['Limited Edition', 'Лимитированный'],
  'CARGO Case': ['XL Container', 'XL Контейнер'],
  'Ambassador Case': ['Unique Case', 'Уникальный'],
} as const

export const CaseTypeRu: Record<string, string> = {
  'GAMED Case': 'Стандартный',
  'Telegram Gift Case': 'Стандартный',
  'Trending Box': 'Лимитированный',
  'CARGO Case': 'Стандартный',
  'Ambassador Case': 'Уникальный',
  'Steam On! Case': 'Уникальный',
  'PS 5 Limited Case': 'Уникальный',
  'City Holder Case': 'Особое событие',
  'Apps Center Case': 'Особое событие',
}
export const CaseTypeEn: Record<string, string> = {
  'GAMED Case': 'Standard',
  'Telegram Gift Case': 'Standard',
  'Trending Box': 'Limited Edition',
  'CARGO Case': 'Standard',
  'Ambassador Case': 'Unique',
  'Steam On! Case': 'Unique',
  'PS 5 Limited Case': 'Unique',
  'City Holder Case': 'Special event',
  'Apps Center Case': 'Special event',
}

export const CaseTimeLimitatonRu: Record<string, string> = {
  'GAMED Case': '',
  'Telegram Gift Case': 'Лимитированный',
  'Trending Box': 'Лимитированный',
  'Ambassador Case': 'Лимитированный',
  'CARGO Case': 'Dota 2',
}

export const CaseTimeLimitatonEn: Record<string, string> = {
  'GAMED Case': '',
  'Telegram Gift Case': 'Limited',
  'Trending Box': 'Limited',
  'Ambassador Case': 'Limited',
  'CARGO Case': 'Dota 2',
}

export const CaseRarityRu: Record<string, string> = {
  'GAMED Case': 'Необычный',
  'Telegram Gift Case': 'Эпический',
  'Trending Box': 'Редкий',
  'Steam On! Case': 'Легендарный',
  'Ambassador Case': 'Легендарный',
  'CARGO Case': 'Легендарный',
  'City Holder Case': 'Эпический',
  'PS 5 Limited Case': 'Легендарный',
  'Apps Center Case': 'Редким',
}
export const CaseRarityEn: Record<string, string> = {
  'GAMED Case': 'Uncommon',
  'Telegram Gift Case': 'Epic',
  'Trending Box': 'Rare',
  'Steam On! Case': 'Legendary',
  'Ambassador Case': 'Legendary',
  'CARGO Case': 'Legendary',
  'PS 5 Limited Case': 'Legendary',
  'City Holder Case': 'Epic',
  'Apps Center Case': 'Rare',
}

export type ShopItemType = {
  id: number
  amount: number
  price_stars: number
  usd_price: number
  ton_price: number
  photo_url: string
}
